export const PRICE_SET = 'at/licenses/addUsersCard/PRICE_SET'
export const USERS_COUNT_SET = 'at/licenses/addUsersCard/USERS_COUNT_SET'
export const UNLIMITED_SET = 'at/licenses/addUsersCard/UNLIMITED_SET'
export const LICENSE_ID_SET = 'at/licenses/addUsersCard/LICENSE_ID_SET'



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/licenseList/addUsers/actionTypes.js